import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M440-440v120q0 17 11.5 28.5T480-280t28.5-11.5T520-320v-120h120q17 0 28.5-11.5T680-480t-11.5-28.5T640-520H520v-120q0-17-11.5-28.5T480-680t-28.5 11.5T440-640v120H320q-17 0-28.5 11.5T280-480t11.5 28.5T320-440zM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-80h560v-560H200zm0-560v560z" }, null, -1)
  ])))
}
export default { render: render }